<template>
  <div id="app">
    <div v-if="this.$route.name in routerList">
      <router-view />
    </div>
    <div v-else>
      <TopBar></TopBar>
      <router-view />
      <Webinfo></Webinfo>
      <div class="Contact" @click="dialogFormVisible2 = true">
        <img
          src="https://ar-scene-source.nosdn.127.net/bfb0e0e5a3dedbeae7bf77d00be8dbb9/images/index/xuanfuanniu.png"
          alt=""
        />
      </div>
      <ContactUs
        :dialogFormVisible="dialogFormVisible2"
        @returnCall="contact"
      ></ContactUs>
    </div>
    <!-- <div class="shangbiao">
      <img
        src="https://college-1255372491.oss-cn-hangzhou.aliyuncs.com/webimg.png"
        alt=""
      />
    </div> -->
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import Webinfo from "@/components/WebInfo";
import ContactUs from "@/components/ContactUs";
export default {
  data() {
    return {
      routerList: {
        edit: "edit",
        register: "register",
        sound: "sound",
        test: "test",
      },
      // dialogTableVisible: false,
      dialogFormVisible2: false,
      // form: {
      //   name: '',
      //   region: '',
      //   date1: '',
      //   date2: '',
      //   delivery: false,
      //   type: [],
      //   resource: '',
      //   desc: ''
      // },
      // formLabelWidth: '120px'
    };
  },

  components: {
    TopBar,
    Webinfo,
    ContactUs,
  },
  mounted() {
    console.log(this.$route.name in this.routerList);
  },
  methods: {
    contact(e) {
      if (e == true) {
        this.$message({
          showClose: true,
          message: "提交成功，我们会尽快与您联系",
          type: "success",
        });
      }

      this.dialogFormVisible2 = false;
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.Contact {
  width: 60px;
  height: 130px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 9999;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}

.shangbiao {
  width: 200px;
  height: 60px;
  position: fixed;
  z-index: 9999;
  top: 50%;
  animation: identifier 10s ease-in-out infinite;
}

.shangbiao img {
  width: 100%;
  height: 100%;
}

@keyframes identifier {
  0% {
    left: 0;
  }

  50% {
    left: calc(100% - 200px);
  }

  100% {
    left: 0;
  }
}
</style>
